module.exports = __webpack_public_path__ + "assets/img/Gourmet-Basket-eBook-w540.2e29333c.jpg";